// Absolute base for API calls, prepended to every `/api/...` request.
//
// Empty by default → same-origin, which is correct for:
//   • production (the SPA and /api/* share one CloudFront distribution), and
//   • local `npm run dev` (the Vite proxy forwards /api).
//
// A standalone S3-hosted build has no proxy and no same-origin API, so set
// `VITE_API_BASE` at build time to the UAT Lambda Function URL (no trailing
// slash); the Function URL's own CORS config allows the S3 site's origin.
export const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, '');
